import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import Flux from '../Flux';

const CHANGE_EVENTS = {
	tvSeriesDataChange: 'tvSeriesDataChange',
	tvSeriesLoad: 'tvSeriesLoad',
};

let _tvSeries = {};
let _tvSeriesLoading = false;

const TVSeriesStore = assign({}, FluxEventEmitter.prototype, {
	EVENTS: CHANGE_EVENTS,

	/**
	 * @returns {Object[]|null}
	 */
	getTVSeries: function () {
		return _tvSeries['items'] || null;
	},

	/**
	 * @returns {*|null}
	 */
	getTVSeriesTotalCount: function () {
		return _tvSeries['total'] || null;
	},

	/**
	 *
	 * @returns {boolean}
	 */
	isTVSeriesLoading: function () {
		return _tvSeriesLoading || false;
	},

	// Direct method (previously handled via action)
	loadTVSeries: function (count, offset = 0) {
		_tvSeriesLoading = true;
		TVSeriesStore.emit(CHANGE_EVENTS.tvSeriesLoad);
		Flux.Vxql.getTVSeriesFromVXQL(count, offset).then(({ data }) => {
			const newData = data.tv.series;

			if (newData) {
				let tvSeriesData = _tvSeries;

				if (!tvSeriesData) {
					tvSeriesData = {};
				}

				tvSeriesData.total = newData.total;

				let tvSeries = tvSeriesData.items;

				if (!tvSeries) {
					tvSeries = {};
					tvSeriesData.items = tvSeries;
				}

				for (const [index, series] of newData.items.entries()) {
					tvSeries[offset + index] = series;
				}

				_tvSeries = tvSeriesData;

				_tvSeriesLoading = false;

				TVSeriesStore.emit(CHANGE_EVENTS.tvSeriesLoad);
				TVSeriesStore.emit(CHANGE_EVENTS.tvSeriesDataChange);
			}
		});
	},
});

export default TVSeriesStore;
